














import Vue from "vue";
import { AuthRepository } from "../../../auth";

export default Vue.extend({
  name: "AuthButtons",
  data() {
    return {
      currentUser: AuthRepository.getCurrentUser()
    };
  },
  computed: {
    queryParams(): {} {
      if (this.$route?.query?.from) {
        return this.$route.query;
      }

      return {};
    }
  },
  methods: {
    async signOut() {
      AuthRepository.signOut();
      window.location.href = this.$router.resolve({ name: "root_path" }).href;
    }
  }
});
